import routeReducer from './route';
export * from './route';

export default { route: routeReducer };
